module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-title-3-61888a9226eec5213252247e07a0e0e8.png";